import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'cx_foundations-i_need_more_help-click';
/**
 * Click event when I need more help happens
 */
export function trackCxFoundationsINeedMoreHelpClick(issueTree, retailerToken, brandToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { issueTree, retailerToken, brandToken },
    });
}
